<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'

import { usePageStore } from '../../stores/page'
import { useProductGroup } from '../../composables/use-product-group'

const props = withDefaults(defineProps<{
  productGroupType?: string
  manualProductIncluded?: boolean
  affiliateType?: string
}>(), {
  productGroupType: 'single',
  manualProductIncluded: false,
  affiliateType: 'product-group'
})

const { badgeStyleClasses } = useProductGroup({
  productGroupType: () => props.productGroupType,
  affiliateType: () => props.affiliateType
})

const popoverVisible = ref(false)

const pageStore = usePageStore()
const { disclaimerOpen } = storeToRefs(pageStore)
const { toggleAffiliateDisclaimer } = pageStore

const showAffiliateInfo = computed(() => props.manualProductIncluded || props.affiliateType === 'affiliate-link')

const scrollToAffiliateDisclaimer = () => {
  const affiliateDisclaimer = document.getElementById('bx-disclaimer-affiliate')
  if (!affiliateDisclaimer) return

  const scrollOffset = 70 // height of sticky header plus some extra space
  const affiliateDisclaimerTop = affiliateDisclaimer.getBoundingClientRect().top + window.scrollY - scrollOffset
  if (!disclaimerOpen.value) {
    toggleAffiliateDisclaimer()
  }
  window.scrollTo({
    top: affiliateDisclaimerTop,
    behavior: 'smooth'
  })
}
</script>

<template>
  <div class="bx-affiliate-info">
    <span :class="badgeStyleClasses"
          :data-tc="`${affiliateType}-badge`" />
    <i v-if="showAffiliateInfo"
       class="bx-affiliate-info__icon"
       @touchend.prevent="popoverVisible = !popoverVisible"
       @mouseover="popoverVisible = true"
       @mouseout="popoverVisible = false">
      <svg class="icon icon-info">
        <use href="#info" />
      </svg>
      <div v-show="popoverVisible"
           class="bx-affiliate-info__popover bx-typo--affiliate-info-popover">
        <div>
          Dieser Artikel enthält Affiliate Links.
          <a href="#"
             @touchend.prevent="scrollToAffiliateDisclaimer"
             @click.prevent="scrollToAffiliateDisclaimer">
            Mehr erfahren
          </a>
        </div>
      </div>
    </i>
  </div>
</template>
